export const PAY_METHOD = {
    APPLE_PAY: 'apple_pay',
    GOOGLE_PAY: 'google_pay',
    CARD: 'card',
    PAYPAL: 'paypal',
} as const;

export type TPayMethod = (typeof PAY_METHOD)[keyof typeof PAY_METHOD];

/** 业务侧传入的站内回跳 pathname（可带 `/`，如 `/reader`）；创单时会去掉前导 `/` 再写入 return_scene。 */
export type TPayReturnScene = string;

export const ORDER_FROM = {
    PAYWALL: 'paywall',
    PROFILE: 'profile',
} as const;

export type TPayGoodsType = 'recharge' | 'subscribe';

export const PAY_GATEWAY = {
    PAYPAL: 'paypal',
    STRIPE: 'stripe',
} as const;

export type TPayGateway = (typeof PAY_GATEWAY)[keyof typeof PAY_GATEWAY];

export const STRIPE_WALLET_MODE = {
    APPLE_PAY: PAY_METHOD.APPLE_PAY,
    GOOGLE_PAY: PAY_METHOD.GOOGLE_PAY,
} as const;

export type TStripeWalletMode = (typeof STRIPE_WALLET_MODE)[keyof typeof STRIPE_WALLET_MODE];

export type TStripeSheetMode = TStripeWalletMode | typeof PAY_METHOD.CARD;

export const ALL_PAY_METHODS: readonly TPayMethod[] = [
    PAY_METHOD.PAYPAL,
    PAY_METHOD.APPLE_PAY,
    PAY_METHOD.GOOGLE_PAY,
    PAY_METHOD.CARD,
];
